/**
 * Validation V2 Repository - GraphQL Mutations
 *
 * 7 mutation operations for Validation primitive data modification.
 */

import { gql } from '@apollo/client';
import { VALIDATION_FIELDS_FRAGMENT } from './fragments';

export const CREATE_VALIDATION = gql`
  ${VALIDATION_FIELDS_FRAGMENT}
  mutation CreateValidation($tenantId: String!, $input: CreateValidationInput!) {
    createValidation(tenantId: $tenantId, input: $input) {
      ...ValidationFields
    }
  }
`;

export const UPDATE_VALIDATION = gql`
  ${VALIDATION_FIELDS_FRAGMENT}
  mutation UpdateValidation($tenantId: String!, $code: String!, $input: UpdateValidationInput!) {
    updateValidation(tenantId: $tenantId, code: $code, input: $input) {
      ...ValidationFields
    }
  }
`;

export const DELETE_VALIDATION = gql`
  mutation DeleteValidation($tenantId: String!, $code: String!) {
    deleteValidation(tenantId: $tenantId, code: $code)
  }
`;

export const ACTIVATE_VALIDATION = gql`
  ${VALIDATION_FIELDS_FRAGMENT}
  mutation ActivateValidation($tenantId: String!, $code: String!) {
    activateValidation(tenantId: $tenantId, code: $code) {
      ...ValidationFields
    }
  }
`;

export const DEACTIVATE_VALIDATION = gql`
  ${VALIDATION_FIELDS_FRAGMENT}
  mutation DeactivateValidation($tenantId: String!, $code: String!) {
    deactivateValidation(tenantId: $tenantId, code: $code) {
      ...ValidationFields
    }
  }
`;

export const ADD_DEPENDENCY = gql`
  ${VALIDATION_FIELDS_FRAGMENT}
  mutation AddValidationDependency($tenantId: String!, $code: String!, $dependsOnCode: String!) {
    addValidationDependency(tenantId: $tenantId, code: $code, dependsOnCode: $dependsOnCode) {
      ...ValidationFields
    }
  }
`;

export const REMOVE_DEPENDENCY = gql`
  ${VALIDATION_FIELDS_FRAGMENT}
  mutation RemoveValidationDependency($tenantId: String!, $code: String!, $dependsOnCode: String!) {
    removeValidationDependency(tenantId: $tenantId, code: $code, dependsOnCode: $dependsOnCode) {
      ...ValidationFields
    }
  }
`;
